import React from "react";
import { Input, Radio, Space } from "antd";

export default function TtRadio(props) {
  const { component, currentConfig, handleChange, toIntIf } = props;
  return (
    <Radio.Group
      value={currentConfig[component.name] || null}
      name={component.name}
      onChange={(e) => {
        const value = e.target.value;
        handleChange({ [component.name]: toIntIf(value) });
      }}
    >
      <Space direction="vertical">
        {component.permittedValues.map((v) => {
          if (typeof v === "object" && v !== null) {
            return <Radio value={1}>Option A</Radio>;
          }
          return <Radio value={v}>{v}</Radio>;
        })}
      </Space>
    </Radio.Group>
  );
}
